import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/local/target.css?{\"path\":\"src/shared/styles/fonts/font.ts\",\"import\":\"\",\"arguments\":[{\"variable\":\"--font-suisse\",\"display\":\"swap\",\"src\":[{\"path\":\"../fonts/suisse-intl/Regular/SuisseIntl-Regular.woff2\",\"weight\":\"400\",\"style\":\"normal\"},{\"path\":\"../fonts/suisse-intl/Medium/SuisseIntl-Medium.woff2\",\"weight\":\"500\",\"style\":\"normal\"},{\"path\":\"../fonts/suisse-intl/SemiBold/SuisseIntl-SemiBold.woff2\",\"weight\":\"600\",\"style\":\"normal\"}]}],\"variableName\":\"suisseInt\"}");
;
import(/* webpackMode: "eager", webpackExports: ["FeedbackFormContainer"] */ "/app/src/app/[locale]/(with-common-layout)/FeedbackFormContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(with-common-layout)/searchScrollTemplate.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/iconArrow.svg");
;
import(/* webpackMode: "eager", webpackExports: ["ArticleCard"] */ "/app/src/shared/components/articleCard/ui/ArticleCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/shared/components/casesSlider/ui/MobileSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/shared/components/ClientImport/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Cookies"] */ "/app/src/shared/components/cookies/ui/Cookies.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/app/src/shared/components/footer/ui/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HalfPageSlider"] */ "/app/src/shared/components/halfPageSlider/ui/HalfPageSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/app/src/shared/components/header/ui/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MainContainer"] */ "/app/src/shared/components/mainContainer/ui/MainContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OnlineChat"] */ "/app/src/shared/components/onlineChat/ui/OnlineChat.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollButtonToTop"] */ "/app/src/shared/components/scrollButtonToTop/ui/ScrollButtonToTop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToasterProvider"] */ "/app/src/shared/components/toasterProvider/ui/ToasterProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UTMTracker"] */ "/app/src/shared/components/UTMTracker/UTMTracker.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/shared/styles/globals.css");
